module.exports = __webpack_public_path__ + "img/j5.cccfc9e6.jpg";